import { isSystem } from '@umu/ukit-lang';

interface IProps {
    children: JSX.Element | JSX.Element[];
}

export const DistinctionCO = ({ children }: IProps) => {
    if (isSystem('JP')) {
        return Array.isArray(children) ? children[0] : children;
    }
    return Array.isArray(children) && children.length > 1 ? children[1] : null;
};
